export default __webpack_public_path__ + "static/media/decorative-image-3.a3ddc2cf.jpg";